var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"300","align":"center","value":_vm.isLoading}},[_c('v-sheet',{staticClass:"pa-5",attrs:{"width":"max","align":"center","rounded":""}},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"mt-7"},[_vm._v("Loading")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }